var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';

function SvgAlertInfo(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "#FFF",
    d: "M16 30.54c-8.284 0-15-6.511-15-14.545C1 7.962 7.716 1.45 16 1.45c8.284 0 15 6.512 15 14.545 0 8.034-6.716 14.546-15 14.546zm0-2.644c6.778 0 12.273-5.328 12.273-11.9 0-6.573-5.495-11.901-12.273-11.901S3.727 9.423 3.727 15.995c0 6.573 5.495 11.901 12.273 11.901zm1.364-6.611c0 .73-.61 1.322-1.364 1.322-.753 0-1.364-.592-1.364-1.322v-5.29c0-.73.61-1.322 1.364-1.322.753 0 1.364.592 1.364 1.322v5.29zm-2.328-8.321a1.294 1.294 0 010-1.87 1.394 1.394 0 011.928 0 1.294 1.294 0 010 1.87 1.394 1.394 0 01-1.928 0z"
  }));
}

export default SvgAlertInfo;